<script setup>
import { ref, watch } from 'vue';
import SvgIcon from 'JIX/components/SvgIcon.vue';

defineProps({
    inputClasses: {
        type: String,
        default: 'form-control form-control-lg',
    },
    icon: {
        type: Object, // should contain size and name and the consumer/parent should import the svg icon.
        required: true,
    }
});

const model = defineModel(String);

defineOptions({
    inheritAttrs: false
});


const inputRef = ref();

defineExpose({
    focusInput: () => inputRef.value?.focus(),
    unFocusInput: () => inputRef.value?.blur(),
});

watch(model, () => inputRef.value.setCustomValidity(""));

</script>

<template>
    <div class="d-flex align-items-center bg-input border-pill">
        <SvgIcon
            class="ml-4"
            :name="icon.name"
            :size="icon.size"
        />
        <input
            v-bind="$attrs"
            :value="model"
            @input="e => model = e.target.value"
            enterhint="search"
            type="search"
            class="pl-2"
            autocomplete="off"
            :class="inputClasses"
            ref="inputRef"
        >
    </div>
</template>
